import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course/course.service';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
import { FaceVerificationPage } from '../face-verification/face-verification.page';
import { QuizParams } from 'src/app/interfaces/answer';
import { errorMessages } from 'src/app/interfaces/error-messages';
import { FaceRecogPage } from '../face-recog/face-recog.page';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-module-progress-quiz',
  templateUrl: './module-progress-quiz.page.html',
  styleUrls: ['./module-progress-quiz.page.scss'],
})
export class ModuleProgressQuizPage implements OnInit {
  res;
  state = 'guideline';
  courseId;
  topicId;
  topic;
  detailId;
  submittingQuiz = false;
  quizActive = 0;
  intervalId;
  counter: { min: number; sec: number };
  clockCSS = 'basic';

  guideline;

  title;
  subtitle;
  quizType;
  content;
  cmsTable;
  languages;
  moduleId;
  topicStatus;

  faceTopics;// = [2,12,19,50,66,70,100,106,114,130,190,196,222,230,270,292,500,524,534,560,587,620,650];
  faceTopicsQuiz;

  constructor(
    private courseService: CourseService,
    public actionSheetController: ActionSheetController,
    private navCtrl: NavController,
    private couseService: CourseService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingCtrl: LoadingController,
    public modalController: ModalController
  ) { }

  ngOnInit() { }

  quizParams: any;

  ionViewDidEnter() {
    //this.presentLoading('Loading Guidelines...');

    //For Quiz Only
/*     this.userService.getFaceTopics().then((res:any)=>{
      this.faceTopicsQuiz = res.result[0].faceTopics;
      localStorage.setItem('topicsListQuiz', this.faceTopicsQuiz);
    });

    this.faceTopicsQuiz = JSON.parse("[" + localStorage.getItem('topicsList') + "]");  */

    this.quizParams = null;
    this.quizParams = history.state.data;
    //console.log(this.quizParams);
    this.courseId = this.quizParams.courseId;
    this.topicId = this.quizParams.topicId;
    this.detailId = this.quizParams.topicDetailsId;
    this.topicStatus = this.quizParams.moduleStatus;
    //this.courseId = this.route.snapshot.params['courseId'];
    //this.topicId = this.route.snapshot.params['topicId'];
    //this.detailId = this.route.snapshot.params['topicDetailId'];

    this.couseService.getTopicDetail(this.detailId).then((res: any) => {
      if (res.statusCode == 200) {
        this.topic = res.result[0];
      }
    });

    this.loadGuideline();
  }

  loadGuideline() {
    this.courseService
      .getGuideline(this.topicId)
      .then((res: any) => {
        this.guideline = res.result[0];
        //console.log(this.guideline);
        this.quizType = this.guideline.quizType;
        this.cmsTable = this.guideline.quizGuidelines;
        this.languages = this.guideline.languages;
        var blocks = [];
        _.forEach(this.cmsTable, function (value, key) {
          blocks[value.block] = value.content;
        });

        if (this.quizType == 'QUIZ') {
          this.title = blocks['quiz-title'];
          this.subtitle = blocks['quiz-subtitle'];
          this.content = blocks['quiz-content'];
        } else {
          this.title = blocks['exam-title'];
          this.subtitle = blocks['exam-subtitle'];
          this.content = blocks['exam-content'];
        }
        //this.loading.dismiss();
      })
      .catch((err) => {
        //this.loading.dismiss();
      });
  }

  loadQuizzes(lang: any) {
    this.courseService
      .getTopicQuizzes(this.courseId, this.topicId, lang.code)
      .then((res: any) => {
        this.res = res.result[0];
        this.startQuiz();
        //console.log(this.res)
      });
  }

  async presentActionSheet() {
    var languages = [];

    this.languages.forEach((lang) => {
      languages.push({
        text: lang.name,
        handler: () => {
          this.loadQuizzes(lang);
          //console.log(lang)
        },
      });
    });

    const actionSheet = await this.actionSheetController.create({
      header: 'Select Language',
      cssClass: 'my-custom-class',
      buttons: languages,
    });
    await actionSheet.present();
    const { role } = await actionSheet.onDidDismiss();
  }

  back() {
    this.navCtrl.navigateBack(
      'student/module-progress-detail/' + this.detailId
    );
    /*     this.router.navigate([
          'student/module-progress-detail/'], {state: {data: this.detailId}}
        ); */
  }

  


  async faceVerification() {
    var _this = this;
    const modal = await this.modalController.create({
      component: FaceVerificationPage,
      cssClass: 'my-custom-class',
      backdropDismiss: false,
      componentProps: {
        student: this.quizParams.student,
        topic: this.topic,
        mode: "Quiz/Exam"
      },
    });
    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        if (dataReturned.data.faceVerified == true) {
          this.startTimer();
          this.res.startDate = moment(new Date()).utc().format();
          this.state = 'quiz';
        }
      }
    });
    return await modal.present();
  }

     video;
    async faceRecognition() {
      var _this = this;
      let canvas = document.createElement('canvas');
      this.video = document.getElementById('video');
      canvas.width = 1080;
      canvas.height = 1080;
      let ctx = canvas.getContext('2d');
      ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height);
      let image = canvas.toDataURL('image/jpeg');
  
      var _this = this;
      const modal = await this.modalController.create({
        component: FaceRecogPage,
        cssClass: 'my-custom-class',
        backdropDismiss: false,
        componentProps: {
        student: this.quizParams.student,
        topic: this.topic,
        mode: "Quiz/Exam",
        imageCap: image
        },
      });
      modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
        if (dataReturned.data.faceVerified == true) {
          this.startTimer();
          this.res.startDate = moment(new Date()).utc().format();
          this.state = 'quiz';
        }
      }
    });
    return await modal.present();
    }

  startQuiz() {
    if (this.quizParams.faceVideo == 'true') {

        const myObjectArray: any[] = [
          { topicId: 0 }
        ];

        const targetNumber = this.topicId;
        const foundObject = myObjectArray.find(obj => obj.topicId === targetNumber);

      if (foundObject) {
        if (this.topicStatus != "COMPLETED") {
          //this.faceVerification();
          this.faceRecognition();
        } else {
          this.startTimer();
          this.res.startDate = moment(new Date()).utc().format();
          this.state = 'quiz';
        }
      }
      else {
        this.startTimer();
        this.res.startDate = moment(new Date()).utc().format();
        this.state = 'quiz';
      }

    } else {
      this.startTimer();
      this.res.startDate = moment(new Date()).utc().format();
      this.state = 'quiz';
    }
  }

  nextQuestion() {
    this.res.quizzes[this.quizActive].duration = this.counter.sec;

    if (this.quizActive == this.res.quizzes.length - 1) {
      this.submittingQuiz = true;
      this.finish();
    } else {
      this.startTimer();
      this.quizActive = this.quizActive + 1;
    }
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.counter = { min: 0, sec: 60 }; // choose whatever you want
    this.intervalId = setInterval(() => {
      if (this.counter.sec - 1 == -1) {
        this.counter.min -= 1;
        this.counter.sec = 59;
      } else {
        this.counter.sec -= 1;

        if (this.counter.sec <= 10) {
          //this.clockCSS = 'alarming';
        } else {
          // this.clockCSS = 'basic';
        }

        if (this.counter.min === 0 && this.counter.sec == 0) {
          clearInterval(this.intervalId);
          this.nextQuestion();
          //this.clockCSS = 'basic';
        }
      }
    }, 1000);
  }

  loading;
  async presentLoading(msg) {
    this.loading = await this.loadingCtrl.create({
      cssClass: 'my-custom-class',
      message: msg,
    });
    await this.loading.present();
  }

  results;

  finish() {
    //this.presentLoading('Loading Your Result...');
    this.res.endDate = moment(new Date()).utc().format();
    clearInterval(this.intervalId);
    this.courseService.saveTopicQuiz(this.res).then((res: any) => {
      if (res) {
        this.results = res.result[0];
        this.submittingQuiz = false;
        //this.loading.dismiss();
        this.state = 'result';
        //console.log(res.result[0]);
      }
      else {
        //this.loading.dismiss();
      }
    })
      .catch(function (error) {
        console.log(error);
        //this.cmsService.errorMessageToast(errorMessages.connectionTimeOut);
      });
  }
}
